<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
            <!--page body contant -->

            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-p h5">
                    <h4 class="add-m-tb"><i class="fa fa-credit-card"></i> DASHBOARD EXPENSES</h4>
                </div>
                <div class="col-md-6 top-corner-items col-p">
                  <button class="btn btn-primary btn-sm" [routerLink]="['/dashboard']"><i class="fa fa-arrow-left"></i> Back</button>
                </div>
            </div>


            <!-- <div class="row row-replace add-m-b">
                <div class="col-12 col-p h5 b-b">
                    <h4 class="add-m-tb"><i class="fa fa-credit-card"></i> DASHBOARD EXPENSES</h4>
                </div>
            </div> -->
            <!--end header-->

            <div class="row row-replace">
                <section class="col-md-3 col-lg-3 card"> 
                   <div class="container">
                       <div class="row text-center add-m-tb">
                           <div class="col-6">
                                <a [routerLink]="['/dashboard/addexpence']">
                                <div class="h3"><i class="fa fa-inr"></i></div>
                                <div>New Expenses</div>
                                </a>
                           </div>
                           <div class="col-6">
                                <a [routerLink]="['/dashboard/expensereport']">
                                <div class="h3"><i class="fa fa-file-text"></i></div>
                                <div>New Report</div>
                                </a>
                           </div>
                       </div>
                   </div> 
                </section>
                <section class="col-md-6 col-lg-6 card">
                    <div class="container">
                        <div class="row text-center add-m-tb">
                            <div class="col-4">
                                <div class="text-danger">UNSUBMITED</div>
                                <h1 class="margin-bottom0"><i class="fa fa-inr"></i> 3521</h1>
                                <div>2 Reports</div>
                            </div>
                            <div class="col-4">
                                <div class="text-success">SUBMITED</div>
                                <h1 class="margin-bottom0"><i class="fa fa-inr"></i> 3521</h1>
                                <div>2 Reports</div>
                            </div>
                            <div class="col-4">
                                <div class="text-warning">AWAITING REIMBURSEMENT</div>
                                <h1 class="margin-bottom0"><i class="fa fa-inr"></i> 3521</h1>
                                <div>2 Reports</div>
                            </div>
                        </div>
                    </div> 
                </section>
                <section class="col-md-3 col-lg-3 col-p card">
                    <div class="container">
                        <div class="row text-center add-m-tb ">
                           <div class="col-9 col-p"><input type="text" class="form-control"></div>
                           <div class="col-3 col-p"><button class="btn btn-success btn-sm">Search</button></div>
                        </div>
                    </div> 
                </section>
            </div>

            <div class="row row-replace m-t-30">
                <div class="col-12">
                    <p> <i class="fa fa-list"></i> My Expenses</p>
                       <div class="table-responsive">
                           <table class="table">
                               <tr class="bg-primary text-white">

                                  <th>
                                    <span><input type="checkbox"></span>
                                    <span class="ml-10">ID</span>
                                  </th>
                                  <th>Date</th>
                                  <th>Category</th>
                                  <th>Merchant</th>
                                  <th>Report</th>
                                  <th>Status</th>
                                  <th><i class="fa fa-inr"></i> Amount</th>
                               </tr>
                               <tr>
                                <th>
                                    <span><input type="checkbox"></span>
                                    <span class="ml-10" (click)="expenseDetails()">1</span>
                                  </th>
                                  <td>27/02/2021</td>
                                  <td>Mobile Expense</td>
                                  <td></td>
                                  <td>Exense Report</td>
                                  <td>Approved</td>
                                  <td>3254</td>
                               </tr>
                           </table>
                        </div>
                   </div>
            </div>

           
          
    

      <!--end page body contant -->
        </div>
    </div>
</div>
<!-- /Page Wrapper -->           




<!--expense view details modal-->

<div class="modal custom-modal fade" id="expense_details" role="dialog" style="display: none;" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
       <div class="modal-content">
          <div class="modal-header">
             <h5 class="modal-title">Expense Details</h5>
             <button type="button" class="close" data-dismiss="modal" aria-label="Close">
             <span aria-hidden="true">×</span>
             </button>
          </div>
          <div class="modal-body">
             <div class="container-fluid">
                <div class="row row-replace">
                   <div class="col-md-6">
                      <div class="form-group">
                         <div class="row">
                            <div class="col-4">
                               <label for="aaaa">Expense Type<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                               <input type="text" class="form-control" placeholder="expense type">
                            </div>
                         </div>
                      </div>
                      <div class="form-group">
                         <div class="row">
                            <div class="col-4">
                               <label for="aaaa">Month / Date*<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-4">
                              <p>From Date</p>
                            </div>
                            <div class="col-4">
                              <p>To Date</p>
                            </div>
                         </div>
                      </div>
                      <div class="form-group">
                         <div class="row">
                            <div class="col-4">
                               <label for="aaaa">Attach Bill/ Attach Payment receipt<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                               <input type="text" class="form-control">
                            </div>
                         </div>
                      </div>
                   </div>
                   <div class="col-md-6">
                      <div class="form-group">
                         <div class="row">
                            <div class="col-4">
                               <label for="aaaa">Amount<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                               <input type="text" class="form-control" placeholder="Amount">
                            </div>
                         </div>
                      </div>
                      <div class="form-group">
                         <div class="row">
                            <div class="col-4">
                               <label for="aaaa">PC Code<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                               <input type="text" class="form-control" placeholder="enter pc code">
                            </div>
                         </div>
                      </div>
                      <div class="form-group">
                         <div class="row">
                            <div class="col-4">
                               <label for="aaaa">Mode of Transport<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                               <input type="text" class="form-control" placeholder="Mode of transport">
                            </div>
                         </div>
                      </div>
                      <div class="form-group">
                         <div class="row">
                            <div class="col-4">
                               <label for="aaaa">Remark<span class="text-danger">*</span></label>
                            </div>
                            <div class="col-8">
                               <textarea rows="3" class="form-control"></textarea>
                            </div>
                         </div>
                      </div>
                   </div>
                </div>
                <!--modal table -->
                <div class="row">
                   <div class="col-12">
                      <div class="table-responsive">
                         <table class="table">
                            <tr class="bg-primary text-white">
                               <th>
                                  <span><input type="checkbox"></span>
                                  <span class="ml-10">ID</span>
                               </th>
                               <th>Date</th>
                               <th>Category</th>
                               <th>Merchant</th>
                               <th>Report</th>
                               <th>Status</th>
                               <th><i class="fa fa-inr"></i> Amount</th>
                            </tr>
                            <tr>
                               <th>
                                  <span><input type="checkbox"></span>
                                  <span class="ml-10">1</span>
                               </th>
                               <td>27/02/2021</td>
                               <td>Mobile Expense</td>
                               <td></td>
                               <td>Exense Report</td>
                               <td>Approved</td>
                               <td>3254</td>
                            </tr>
                         </table>
                      </div>
                   </div>
                </div>
                <div class="form-group">
                   <div class="row">
                      <div class="col-12 text-center">
                         <button class="btn btn-primary btn-sm">Submit</button>
                         <button class="btn btn-danger btn-sm ml-10">Cancel</button>
                      </div>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>